import Box from "@sendsprint/ui-react/components/box";
import AccordionList from "./accordionList";
import { AccordionItemProps } from "./accordionItem";

interface Props {
  faqData: AccordionItemProps[];
}

const GlobalAccordion = ({ faqData }: Props) => {
  return (
    <Box as="section" className="ss:max-w-[750px] ss:mx-auto">
      <AccordionList dropdownItems={faqData} />
    </Box>
  );
};

export default GlobalAccordion;
